import {
  GraphQLID,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean
} from 'graphql'

export interface BaseCompliancePolicy {
  readonly id: string
  readonly name: string
  readonly enabled: boolean
}

export const BaseCompliancePolicyType = new GraphQLObjectType({
  name: 'BaseCompliancePolicy',
  description: 'A user defined policy for vulnerabilities',
  fields: () => ({
    id: {
      description: 'The unique ID for the policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'A displayable name for the policy',
      type: new GraphQLNonNull(GraphQLString)
    },
    enabled: {
      description: 'Is the policy enabled for the organization',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export interface CompliancePolicy extends BaseCompliancePolicy {
  readonly key?: string
}

export const CompliancePolicyType = new GraphQLObjectType({
  name: 'CompliancePolicy',
  description: 'A user defined policy for vulnerabilities',
  fields: () => ({
    id: {
      description: 'The unique ID for the policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'A displayable name for the policy',
      type: new GraphQLNonNull(GraphQLString)
    },
    enabled: {
      description: 'Is the policy enabled for the organization',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    key: {
      description: 'A key for the policy',
      type: GraphQLString
    }
  })
})
